import React from "react";
import { AdminuUserContainer } from "./AdminUserContainer";
import { TalkListContainer } from "./TalkListContainer";
import { UserListContainer } from "./UserListContainer";

interface IProps {
  children: React.ReactNode;
}

const ContainerProvider: React.FC<IProps> = ({ children }) => (
  <TalkListContainer.Provider>
    <UserListContainer.Provider>
      <AdminuUserContainer.Provider>{children}</AdminuUserContainer.Provider>
    </UserListContainer.Provider>
  </TalkListContainer.Provider>
);

/*
Wish (記 ナッシー) 8/4:
  ContainerProvider コンポーネントを unstated ライブラリの Subscribe のように
  書き直したい。
 
<Subscribe to={[CounterContainer]}>
  {counter => (
    <div>
      ...
  </div>
  )}
</Subscribe>

理由:
  いけてないから。
 
  現状、コンテイナーが増えるたびに、ContainerProvider コンポーネントにそのコンテイナーを
  書き足して、子ノードをラップしないといけない。
 
  上記の Subscribe はこの ContainerProvider と同じコンテイナーで子ノードをラップする責務を
  担っているが、コンテイナーを要素とした配列を引数で受け取り、それを内部でラップしているので
  使用者が Subscribe 内部のロジックを気にする必要がなくスマート。
 
  将来的に実装してみたいが、Subscribe 内部をぱっと見た感じすぐに実装できそうになかったので
  あと送りにした。
 
  参照: https://github.com/jamiebuilds/unstated
 
*/

export default ContainerProvider;
